import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class ExternalClick extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ExternalClick',
  };

  /**
   * Click
   * @param {object} props Props
   * @param {object} props.target Current element
   * @returns {void}
   */
  onClick({ target }) {
    window.dataLayer.push({
      event: 'outboundClick',
      current_destination: window.cs_datalayer.current_destination,
      outboundUrl: target.href,
      linkText: target.title ? target.title : target.textContent,
      pageUrl: window.location.href,
      page_type: window.cs_datalayer.page_type,
      page_title: window.cs_datalayer.page_title,
      referrer: document.referrer,
    });
  }
}
